import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {CloseButton} from '../button/close-button/close-button';
import {Stack} from '../layout/stack/stack';
import {Link} from '../link/link';
import {Body} from '../typography/body';

import styles from './promo-banner.module.css';

type Props = {
    /** The illustration component to display on the left side */
    illustration: React.ReactNode;
    /** The title text displayed in bold */
    title: string;
    /** The description text displayed below the title */
    description: string;
    /** The text for the CTA link */
    ctaText: string;
    /** The href/route for the CTA link */
    ctaHref: string;
    /** Whether the CTA link should use react-router */
    isRoutedLink?: boolean;
    /** Callback when the dismiss button is clicked */
    onDismiss: () => void;
};

/**
 * A promotional banner with a 50-50 split layout.
 * Left side displays an illustration, right side displays text content with a CTA link.
 * Includes a close button to dismiss the banner.
 */
export function PromoBanner(props: Props) {
    const {isRoutedLink = true} = props;

    const linkProps = isRoutedLink
        ? {
              as: RoutedLink,
              to: props.ctaHref,
          }
        : {href: props.ctaHref};

    return (
        <div className={styles.container}>
            <div className={styles.illustration}>{props.illustration}</div>
            <div className={styles.content}>
                <Stack spacing={4} isFullWidth={true}>
                    <Body isBold={true} size='large'>
                        {props.title}
                    </Body>
                    <Body size='normal'>{props.description}</Body>
                    {/* @ts-expect-error */}
                    <Link variant='primary' size='normal' {...linkProps}>
                        {props.ctaText}
                    </Link>
                </Stack>
                <div className={styles['close-button']}>
                    <CloseButton onClick={props.onDismiss} size={16} />
                </div>
            </div>
        </div>
    );
}
